import { render, staticRenderFns } from "./wgld.vue?vue&type=template&id=cebe7bd0&scoped=true&"
import script from "./wgld.vue?vue&type=script&lang=js&"
export * from "./wgld.vue?vue&type=script&lang=js&"
import style0 from "./wgld.vue?vue&type=style&index=0&id=cebe7bd0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebe7bd0",
  null
  
)

export default component.exports